// NotFoundPage.js - 404页面
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .notfound-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f5f5f7 0%, #ffffff 100%);
          padding: 20px;
          text-align: center;
        }
        
        /* 404 数字和指南针 */
        .error-code-wrapper {
          position: relative;
          margin-bottom: 40px;
        }
        
        .error-code {
          font-size: 180px;
          font-weight: 700;
          color: #e5e7eb;
          letter-spacing: 20px;
          margin: 0;
          line-height: 1;
          position: relative;
        }
        
        /* 中间的圆形指南针容器 */
        .compass-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 120px;
          height: 120px;
          background: white;
          border-radius: 50%;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        /* 指南针 */
        .compass {
          width: 80px;
          height: 80px;
          position: relative;
          animation: rotate 4s linear infinite;
        }
        
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        /* 使用CSS绘制指南针 */
        .compass-needle {
          position: absolute;
          width: 100%;
          height: 100%;
        }
        
        .needle-north {
          position: absolute;
          top: 10%;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-bottom: 30px solid #1b2a41;
        }
        
        .needle-south {
          position: absolute;
          bottom: 10%;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-top: 30px solid #9ca3af;
        }
        
        .compass-center {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 16px;
          height: 16px;
          background: #1b2a41;
          border-radius: 50%;
          z-index: 1;
        }
        
        /* 文字内容 */
        .error-title {
          font-size: 36px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 8px;
        }
        
        .error-title-highlight {
          color: #2a9d8f;
        }
        
        .error-description {
          font-size: 18px;
          color: #6b7280;
          max-width: 500px;
          margin: 0 auto 40px;
          line-height: 1.6;
        }
        
        /* 按钮 */
        .button-group {
          display: flex;
          gap: 16px;
          justify-content: center;
          margin-bottom: 60px;
        }
        
        .btn-primary {
          padding: 12px 32px;
          background: #1b2a41;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .btn-primary:hover {
          background: #2a3a51;
          transform: translateY(-2px);
        }
        
        .btn-secondary {
          padding: 12px 32px;
          background: white;
          color: #1b2a41;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .btn-secondary:hover {
          background: #f9fafb;
          border-color: #d1d5db;
        }
        
        /* 底部建议链接 */
        .suggestions {
          display: flex;
          gap: 60px;
          justify-content: center;
        }
        
        .suggestion-item {
          text-align: center;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .suggestion-item:hover {
          transform: translateY(-4px);
        }
        
        .suggestion-icon {
          width: 60px;
          height: 60px;
          background: #f5f5f7;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 12px;
          transition: all 0.3s;
        }
        
        .suggestion-item:hover .suggestion-icon {
          background: #1b2a41;
          color: white;
        }
        
        .suggestion-icon svg {
          width: 28px;
          height: 28px;
          color: #1b2a41;
        }
        
        .suggestion-item:hover .suggestion-icon svg {
          color: white;
        }
        
        .suggestion-title {
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 4px;
        }
        
        .suggestion-desc {
          font-size: 13px;
          color: #9ca3af;
        }
        
        /* 底部装饰文字 */
        .bottom-text {
          position: absolute;
          bottom: 40px;
          color: #9ca3af;
          font-size: 14px;
        }
        
        /* 响应式 */
        @media (max-width: 768px) {
          .error-code {
            font-size: 120px;
            letter-spacing: 10px;
          }
          
          .compass-container {
            width: 90px;
            height: 90px;
          }
          
          .compass {
            width: 60px;
            height: 60px;
          }
          
          .error-title {
            font-size: 28px;
          }
          
          .error-description {
            font-size: 16px;
          }
          
          .button-group {
            flex-direction: column;
            width: 100%;
            max-width: 280px;
          }
          
          .suggestions {
            gap: 30px;
          }
          
          .suggestion-icon {
            width: 50px;
            height: 50px;
          }
        }
      `}</style>

      <div className="notfound-container">
        <div className="error-code-wrapper">
          <h1 className="error-code">404</h1>
          <div className="compass-container">
            <div className="compass">
              <div className="compass-needle">
                <div className="needle-north"></div>
                <div className="needle-south"></div>
              </div>
              <div className="compass-center"></div>
            </div>
          </div>
        </div>

        <h2 className="error-title">
          Oops! You've wandered <span className="error-title-highlight">off the map</span>
        </h2>
        <p className="error-description">
          Looks like this destination doesn't exist. Don't worry though—every great adventure has a few wrong turns!
        </p>

        <div className="button-group">
          <button className="btn-primary" onClick={() => navigate('/')}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 1L2 6V14H6V10H10V14H14V6L8 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back to Home
          </button>
          <button className="btn-secondary" onClick={() => window.history.back()}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Go Back
          </button>
        </div>

        <div className="suggestions">
          <div className="suggestion-item" onClick={() => navigate('/city-selection')}>
            <div className="suggestion-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7V22H22V7L12 2Z" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 22V12" stroke="currentColor" strokeWidth="2"/>
                <path d="M2 7H22" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <div className="suggestion-title">Explore Cities</div>
            <div className="suggestion-desc">Discover amazing destinations</div>
          </div>

          <div className="suggestion-item" onClick={() => navigate('/trip-planner')}>
            <div className="suggestion-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 6V12L16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="suggestion-title">Search Trips</div>
            <div className="suggestion-desc">Find your perfect getaway</div>
          </div>

          <div className="suggestion-item" onClick={() => navigate('/community')}>
            <div className="suggestion-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                <path d="M23 21V19C23 17.9391 22.5786 16.9217 21.8284 16.1716" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="20" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </div>
            <div className="suggestion-title">Get Inspired</div>
            <div className="suggestion-desc">Browse travel guides</div>
          </div>
        </div>

        <p className="bottom-text">Not all who wander are lost... but you might be</p>
      </div>
    </>
  );
};

export default NotFoundPage;